import styled from 'styled-components';

export const ContentContainer = styled.section`
  display: grid;
  grid-template-columns: ${(props) =>
    props.category ? 'repeat(3,1fr)' : 'repeat(2, 1fr)'};
  column-gap: 16px;
  width: 100%;
  padding: ${(props) => (props.hideMargin ? '0px' : '0 35px')};
  margin-top: 0px;

  &.YelloBackround {
    background-image: url('https://images.myloapp.in/NestJsUploads/1668768366290-YellowWave.svg');

    @media (max-width: 720px) {
      background-image: none;
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 12px;
  }
`;
export const ContentHeading = styled.h1`
  text-align: center;
  color: rgb(78 77 77);
  margin-top: 0px;

  @media (max-width: 720px) {
    margin-top: 10px;
    font-size: 26px;
  }
`;
